import template from '../templates/ForgotPassword.html';
import loader from '../helpers/loader';
import Alerts from 'lib/alerts';
import swal from 'sweetalert2';
import User from 'newModels/user.js';

module.exports = Backbone.View.extend({
    events: {
        'submit .js-form': 'forgotPassword'
    },

    el: '.content',

    initialize: function() {
        _.bindAll(this, 'forgotPassword');
        this.render();
    },

    forgotPassword: function() {
        var self = this;
        var email = self.$('.js-email').val();
        var re = new RegExp(
            '^[a-z0-9\u007F-\uffff!#$%&\'*+\/=?^_`{|}~-]+(?:\.[a-z0-9' +
            '\u007F-\uffff!#$%&\'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-' +
            'z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$', 'i'
        );
        if (!re.test(email)) {
            self.$('.js-error').text('Please enter an email address.').show();
            return false;
        }

        var stopLoader = loader.startFullScreen('.js-send-button');
        User.resetPassword(email)
            .then(() => {
                swal({
                    title: 'Success!',
                    text: 'Password reset request was sent successfully. ' +
                            'Please check your email to reset your password. \n\n' + 
                            '<strong style="color:red;font-style:italic;font-size:14px">'+
                            'Note: Reset Password link will expire after 24 hours.</strong>',
                    type: 'success',
                    customClass: 'sweet-alert-success',
                    confirmButtonColor: Alerts.btnSuccessColor,
                    confirmButtonText: 'OK'
                }, function() {
                    app.mainRouter.navigate('login', {trigger: true});
                });
            })
            .catch(error => {
                let message = error.message;
                // try (and fail silently, if impossible) to get a message
                // from the response
                try {
                    message = error.response.data.error.message;
                } catch (err) { }

                self.$('.js-error').text(message).show();
            })
            .finally(stopLoader());

        return false;
    },

    render: function() {
        this.$el.html(template());
        $('body').addClass('gray-bg');
        this.delegateEvents();
    }
});



// WEBPACK FOOTER //
// ./app/views/ForgotPassword.js